import React, { useState, Component, useRef } from 'react';
import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import authService from '../api-authorization/AuthorizeService'
import debounce from 'lodash.debounce';


export class ProveedoresView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: [],
            paises: []
        };
        if (props.data) {
            this.state.model = props.data
        }
        else {
            this.state.model = { nombre: "", nickname: "", producto_Id: 0, pais_Id: 0, codigo_MAG: "", codigo_Productor: "", vendorCode: "" };
        }
        this.state.modelValidation = {
            nombre: this.state.model.nombre != "",
            producto_Id: this.state.model.producto_Id != 0,
            pais_Id: this.state.model.pais_Id != 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validate = debounce(this.validate, 1000)
        this.load_productos = this.load_productos.bind(this);
        this.load_paises = this.load_paises.bind(this);
    }
    componentDidMount() {
        this.populateData();
    }
    async populateData() {
        this.setState({ loading: true, productos: await this.load_productos(), paises: await this.load_paises() }, async () => {
            this.setState({ loading: false });
        });
        //return responceData;
    }

    handleChange(event) {

        var tempModel = this.state.model;
        tempModel[event.target.name] = event.target.value;
        this.setState({
            model: tempModel
        }, () => {
            this.props.setModalBodyState(this.state).then(() => this.validate());
        });
        
    }
    async validate() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.state.model);
        const response = await fetch('api/Proveedores/validate', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            var validations = await response.json();
            this.setState({
                modelValidation: validations
            }, () => {
                this.props.setModalBodyState(this.state);
            });
        }
    }
    getValidationValue(value) {
        if (value == null || value == undefined) {
            return true;
        }
        else {
            return value;
        }
    }
    
    render() {
        return (
            <div >
                <Form>
                    <i><h3 className="pb-2" >General</h3></i>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="Nombre">
                                    <FormattedMessage id='Nombre del proveedor' />
                                </Label>
                                <Input
                                    id="nombre"
                                    name="nombre"
                                    //placeholder={placeholder}
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.model.nombre}
                                    valid={this.getValidationValue(this.state.modelValidation.nombre)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.nombre)}
                                />
                                <FormFeedback>
                                    {this.state.model.nombre == '' ? <FormattedMessage id='Este campo es requerido' /> : <FormattedMessage id='Este nombre ya esta siendo usado' />}
                                </FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label for="Nickname">
                                    <FormattedMessage id='Nickname' />
                                </Label>
                                <Input
                                    id="nickname"
                                    name="nickname"
                                    //placeholder={placeholder}
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.model.nickname}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="producto_Id">
                                    <FormattedMessage id='Producto' />
                                </Label>
                                <Input
                                    id="producto_Id"
                                    name="producto_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.producto_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.producto_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.productos.map(producto => producto.producto_Id == this.state.model.producto_Id ? (
                                        <option value={producto.producto_Id} selected>
                                            {producto.nombre}
                                        </option>
                                    ) : (<option value={producto.producto_Id}>{producto.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.producto_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label for="pais_Id">
                                    <FormattedMessage id='Pais' />
                                </Label>
                                <Input
                                    id="pais_Id"
                                    name="pais_Id"
                                    type="select"
                                    onChange={this.handleChange}
                                    valid={this.getValidationValue(this.state.modelValidation.pais_Id)}
                                    invalid={!this.getValidationValue(this.state.modelValidation.pais_Id)}
                                >
                                    <option value="0"></option>
                                    {this.state.paises.map(pais => pais.pais_Id == this.state.model.pais_Id ? (
                                        <option value={pais.pais_Id} selected>
                                            {pais.nombre}
                                        </option>
                                    ) : (<option value={pais.pais_Id}>{pais.nombre}</option>))}
                                </Input>
                                <FormFeedback>
                                    {this.state.model.pais_Id == 0 ? <FormattedMessage id='Este campo es requerido' /> : ""}
                                </FormFeedback>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="codigo_MAG">
                                    <FormattedMessage id='Codigo MAG' />
                                </Label>
                                <FormattedMessage id='Nombre'>
                                    {(placeholder) =>
                                        <Input
                                            id="codigo_MAG"
                                            name="codigo_MAG"
                                            //placeholder={placeholder}
                                            type="text"
                                            onChange={this.handleChange}
                                            value={this.state.model.codigo_MAG}
                                        />
                                    }
                                </FormattedMessage>
                            </FormGroup>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    <hr />
                    <i><h3 className="pb-2" >Varianti</h3></i>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="vendorCode">
                                    <FormattedMessage id='VendorCode' />
                                </Label>
                                <Input
                                    id="vendorCode"
                                    name="vendorCode"
                                    type="text"
                                    onChange={this.handleChange}
                                    value={this.state.model.vendorCode}
                                />
                            </FormGroup>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    
                    
                    
                </Form>
            </div>
        );
    }
    async load_productos() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/productos', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const responceData = await response.json();
        //this.setState({ productos: responceData, loading: false });
        return responceData;
    }
    async load_paises() {
        const token = await authService.getAccessToken();

        const response = await fetch('api/paises', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
        });
        const responceData = await response.json();
        //this.setState({ productos: responceData, loading: false });
        return responceData;
    }
}